// assets/pw-gate.js
// Philip Warren delivery gate — ROUTING + UX ONLY. Shopify checkout (native Local
// Delivery + Local Pickup, configured in admin — Phase 1) stays the single source of
// truth for delivery/collection eligibility. This script only decides which destination
// a shopper goes to.
//
// Vintage Superstore (pre-OS-2.0): loaded as a plain <script> after pw-zones.js.
// ES5-safe. No import/export, no dependencies, does NOT use the theme's jQuery.
(function () {
  "use strict";

  var Z = window.PW_ZONES || { prefixes: ["PL", "TR"], matchMode: "area" };

  // Destinations.
  // LOCAL_DEST   = Warren shop entry for PL/TR van-delivery shoppers.
  // COLLECT_DEST = Warren shop entry for collect-in-store shoppers (any postcode);
  //                they choose Local Pickup (Launceston) at checkout.
  // NATIONAL_DEST= hand-off to Pipers with a source tag only (no customer data in URL).
  // LOCAL_DEST + COLLECT_DEST assume Shopify Local Delivery / Local Pickup (Phase 1)
  // are configured, or these paths dead-end at checkout.
  var LOCAL_DEST = "/collections/all";
  var COLLECT_DEST = "/collections/all";
  var NATIONAL_DEST = "https://pipers.co/discount/WARRENS20?redirect=/pages/warrens%3Futm_source%3Dwarrens%26utm_medium%3Dpostcode-gate%26utm_campaign%3Dwarrens20";
  var GATE_PATH = "/pages/start";

  // Outward code of the postcode the shopper just entered, held between "submit" and
  // their nationwide-vs-collect choice on the result screen.
  var pendingOutward = "";

  // ---------- postcode helpers ----------
  function outwardCode(raw) {
    var pc = String(raw).toUpperCase().replace(/\s+/g, "");
    return pc.length > 3 ? pc.slice(0, pc.length - 3) : pc; // UK inward code is always 3 chars
  }
  function areaPrefix(out) { return (out.match(/^[A-Z]+/) || [""])[0]; }
  function isWarrenZone(raw) {
    var out = outwardCode(raw);
    return Z.matchMode === "district"
      ? Z.prefixes.indexOf(out) !== -1
      : Z.prefixes.indexOf(areaPrefix(out)) !== -1;
  }
  function looksLikePostcode(raw) {
    return /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i.test(String(raw).trim());
  }

  // ---------- persistence (cookie + localStorage) ----------
  function save(payload) {
    var v = encodeURIComponent(JSON.stringify(payload));
    document.cookie = "pw_zone=" + v + ";path=/;max-age=" + (60 * 60 * 24 * 30) + ";samesite=lax";
    try { localStorage.setItem("pw_zone", JSON.stringify(payload)); } catch (e) {}
  }
  function clearZone() {
    document.cookie = "pw_zone=;path=/;max-age=0;samesite=lax";
    try { localStorage.removeItem("pw_zone"); } catch (e) {}
  }
  function readSaved() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem("pw_zone")); } catch (e) {}
    if (!s) {
      var m = document.cookie.match(/(?:^|;\s*)pw_zone=([^;]+)/);
      if (m) { try { s = JSON.parse(decodeURIComponent(m[1])); } catch (e2) {} }
    }
    return s;
  }

  // "national" → Pipers; "collect" → Warren pickup; anything else ("local") → Warren delivery.
  function destFor(cohort) {
    if (cohort === "national") { return NATIONAL_DEST; }
    if (cohort === "collect") { return COLLECT_DEST; }
    return LOCAL_DEST;
  }
  function commit(cohort, out) {
    save({ cohort: cohort, outward: out, ts: Date.now() });
    // Modal mode (gate shown as an overlay on a collection/PDP): PL/TR ("local") and
    // collect shoppers keep browsing the page they were already on — no redirect. Only
    // "national" leaves this storefront (hand-off to Pipers). Render the "change" chip
    // straight away so the affordance is present without waiting for the next page load.
    if (inModalMode && cohort !== "national") {
      closeModal();
      renderFlag({ cohort: cohort, outward: out });
      return;
    }
    window.location.assign(destFor(cohort));
  }

  // ---------- modal gate (collection & product pages) ----------
  // Rendered by snippets/pw-gate-modal.liquid; reuses the same #pw-ask/#pw-result IDs
  // as /pages/start, so the shared wiring below drives both. Only ever one at a time.
  var modalEl = document.getElementById("pw-gate-modal");
  var inModalMode = false;
  function openModal() {
    if (!modalEl) { return; }
    inModalMode = true;
    modalEl.hidden = false;
    modalEl.setAttribute("data-open", "");
    var root = document.documentElement;
    if (root) { root.className += " pw-gate-locked"; }
    var pc = document.getElementById("pw-postcode");
    if (pc) { try { pc.focus(); } catch (e) {} }
  }
  function closeModal() {
    if (!modalEl) { return; }
    modalEl.removeAttribute("data-open");
    modalEl.hidden = true;
    var root = document.documentElement;
    if (root) { root.className = root.className.replace(/\s*\bpw-gate-locked\b/g, ""); }
    inModalMode = false;
  }

  // Non-PL/TR shoppers see a choice (nationwide vs collect) instead of a hard redirect.
  function showResult(out) {
    var ask = document.getElementById("pw-ask");
    var result = document.getElementById("pw-result");
    var outEl = document.getElementById("pw-result-outward");
    pendingOutward = out;
    if (outEl) { outEl.textContent = out; }
    if (ask) { ask.style.display = "none"; }
    if (result) { result.hidden = false; }
  }
  function hideResult() {
    var ask = document.getElementById("pw-ask");
    var result = document.getElementById("pw-result");
    if (result) { result.hidden = true; }
    if (ask) { ask.style.display = ""; }
  }

  function decideAndRoute(raw) {
    var out = outwardCode(raw);
    if (isWarrenZone(raw)) { commit("local", out); return; }
    // Outside PL/TR: offer nationwide (Pipers) OR collect-in-store if the result UI exists.
    if (document.getElementById("pw-result")) { showResult(out); }
    else { commit("national", out); } // fallback (no result UI present) → straight to Pipers
  }

  var onGatePage = window.location.pathname.indexOf(GATE_PATH) === 0;

  // ---------- gate page wiring (only runs if the gate UI is present) ----------
  var btn = document.getElementById("pw-submit");
  if (btn) {
    var input = document.getElementById("pw-postcode");
    var err = document.getElementById("pw-error");
    var submit = function () {
      var raw = (input || {}).value || "";
      if (!raw.trim()) { if (err) { err.textContent = "Please enter a postcode."; } return; }
      if (!looksLikePostcode(raw)) { if (err) { err.textContent = "We couldn't read that postcode — please check it."; } return; }
      if (err) { err.textContent = ""; }
      decideAndRoute(raw);
    };
    btn.addEventListener("click", submit);
    if (input) {
      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.keyCode === 13) { e.preventDefault(); submit(); }
      });
      input.addEventListener("input", function () { if (err) { err.textContent = ""; } });
    }

    // Result-screen choices (save the chosen cohort, then route).
    var goNational = document.getElementById("pw-go-national");
    if (goNational) { goNational.addEventListener("click", function (e) { e.preventDefault(); commit("national", pendingOutward); }); }
    var goCollect = document.getElementById("pw-go-collect");
    if (goCollect) { goCollect.addEventListener("click", function (e) { e.preventDefault(); commit("collect", pendingOutward); }); }
    var back = document.getElementById("pw-back");
    if (back) { back.addEventListener("click", function (e) { e.preventDefault(); hideResult(); if (err) { err.textContent = ""; } if (input) { input.focus(); } }); }
  }

  var saved = readSaved();

  // ---------- auto-fire on collection / PDP ----------
  // The gate is triggered by landing on a collection or product page. It fires ONCE:
  // as soon as a cohort is saved (e.g. a PL/TR postcode passes as "local"), the guard
  // below is false on every later page and the modal never shows again.
  var pageType = window.PW_TEMPLATE || "";
  var gateablePage = (pageType === "collection" || pageType === "product");
  if (gateablePage && modalEl && !(saved && saved.cohort)) {
    openModal();
  }

  // ---------- return-visit skip ----------
  // Rewrite Shop link(s) by HREF (not a data-attribute we can't inject into the
  // settings-driven Vintage nav). Text is unchanged, so no visible flash.
  if (saved && saved.cohort) {
    var dest = destFor(saved.cohort);
    var links = document.querySelectorAll('a[href$="/pages/start"], a[href="/pages/start"]');
    Array.prototype.forEach.call(links, function (a) { a.href = dest; });
  }

  // ---------- reversibility affordance (persistent, quiet, site-wide) ----------
  function renderFlag(s) {
    if (document.getElementById("pw-zone-flag")) { return; }
    var body = document.body || document.documentElement;
    if (!body) { return; }

    // The WHOLE chip is the tap target — not just the word "change". On mobile the old
    // 46x18px link was too small and sat under the iOS bottom toolbar, so it read as
    // "visible but not clickable". Fixes: (1) whole-pill button, (2) env(safe-area-inset-bottom)
    // to clear the iOS toolbar/home indicator, (3) z-index above theme bars (.pw-stickybar is 60).
    var baseBottom = document.querySelector(".pw-stickybar") ? 76 : 16;

    var wrap = document.createElement("div");
    wrap.id = "pw-zone-flag";
    wrap.style.cssText = "position:fixed;left:16px;" +
      "bottom:" + baseBottom + "px;" +
      "bottom:calc(" + baseBottom + "px + env(safe-area-inset-bottom, 0px));" +
      "z-index:9990;pointer-events:auto;cursor:pointer;-webkit-tap-highlight-color:transparent;touch-action:manipulation;" +
      "display:inline-flex;align-items:center;gap:9px;background:#00446B;color:#fff;" +
      "font:400 13px/1.35 system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;" +
      "padding:13px 18px;border-radius:999px;box-shadow:0 6px 20px rgba(0,30,50,.22);" +
      "max-width:calc(100vw - 32px)";

    var text;
    if (s.cohort === "local") { text = "Delivering to " + (s.outward || "your area") + " ••••"; }
    else if (s.cohort === "collect") { text = "Collecting at Launceston"; }
    else { text = "Delivering nationwide"; }

    wrap.setAttribute("role", "button");
    wrap.setAttribute("tabindex", "0");
    wrap.setAttribute("aria-label", text + " — change delivery postcode");

    var label = document.createElement("span");
    label.textContent = text;

    var sep = document.createElement("span");
    sep.textContent = "—";
    sep.style.opacity = ".55";

    var change = document.createElement("span");
    change.textContent = "change";
    change.style.cssText = "color:#D6DE52;text-decoration:underline;text-underline-offset:2px;font-weight:600";

    function doChange() { clearZone(); window.location.assign(GATE_PATH); }
    wrap.addEventListener("click", function (e) { e.preventDefault(); doChange(); });
    wrap.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " " || e.keyCode === 13 || e.keyCode === 32) { e.preventDefault(); doChange(); }
    });

    wrap.appendChild(label);
    wrap.appendChild(sep);
    wrap.appendChild(change);
    body.appendChild(wrap);
  }

  if (saved && saved.cohort && !onGatePage) {
    renderFlag(saved);
  }

  // ---------- cart: pre-select Click & Collect for non-PL/TR shoppers ----------
  // UX only — the HARD rule is Zapiet (its Delivery method is restricted to PL/TR, so it
  // refuses Home Delivery outside the zone). This just switches a non-"local" shopper to
  // pickup as the cart loads, so they don't choose Home Delivery and then hit Zapiet's
  // "not available to your area" block. Zapiet | Store Pickup + Delivery loads async, so
  // poll until its JS API and the "pickup" method exist, then set it ONCE (we don't keep
  // overriding — if the shopper deliberately switches back, Zapiet's own validation stops
  // them at checkout anyway).
  if (pageType === "cart" && saved && saved.cohort && saved.cohort !== "local") {
    var zTries = 0;
    var zPoll = setInterval(function () {
      zTries++;
      var Z = window.Zapiet;
      var ready = Z && typeof Z.setCheckoutMethod === "function" &&
        typeof Z.getAvailableCheckoutMethods === "function" &&
        (Z.getAvailableCheckoutMethods() || []).indexOf("pickup") !== -1;
      if (ready) {
        clearInterval(zPoll);
        try { Z.setCheckoutMethod("pickup"); } catch (e) {}
      } else if (zTries > 60) {
        clearInterval(zPoll); // ~15s cap — give up quietly if Zapiet never loads
      }
    }, 250);
  }
})();
